import styled from 'styled-components';

export const AnchorFlexRowCentered = styled.a<{ disabled?: boolean; $muted?: boolean }>`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 0.5rem;
    white-space: nowrap;
    cursor: pointer;
    user-select: none;
    color: ${({ theme }) => theme.tokens.BaseColorBlue700};
    &:hover {
        color: ${({ theme }) => theme.tokens.ComponentActionHover};
    }
    ${({ $muted, theme }) =>
        $muted &&
        `
        color: ${theme.tokens.BaseColorGray600};
    `}
    ${({ disabled }) =>
        disabled &&
        `
        opacity: 0.5;
        cursor: not-allowed;
        pointer-events: none;
    `}
`;
